import fetchJsonp from 'fetch-jsonp';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import type { SearchFormData } from '@/shared/model';
import { adaptCountries, adaptDepartureCities, buildDefaultCriteriaIndex } from './adapter';
import type { FormDataResponse } from './types';

const FORM_DATA_TIMEOUT_MS = 20_000;

const inFlight = new Map<string, Promise<FormDataResponse>>();

export function clearSearchFormDataCache(): void {
  inFlight.clear();
}

export function fetchSearchFormData(formDataUrl?: string): Promise<FormDataResponse> {
  const config = useTravelataAppConfig();
  const url = formDataUrl || config.getFormData;
  const cached = inFlight.get(url);
  if (cached) {
    return cached;
  }
  const request: Promise<FormDataResponse> = requestFormData(url).catch(() => {
    if (inFlight.get(url) === request) {
      inFlight.delete(url);
    }
    return {};
  });
  inFlight.set(url, request);
  return request;
}

async function requestFormData(formDataUrl?: string): Promise<FormDataResponse> {
  const config = useTravelataAppConfig();
  const url = `${config.gatewayUrl}${formDataUrl}`;

  const response = await fetchJsonp(url, { timeout: FORM_DATA_TIMEOUT_MS });
  return response.json<FormDataResponse>();
}

export async function getSearchFormData(url?: string): Promise<SearchFormData> {
  const body = await fetchSearchFormData(url);
  const data = body.data ?? {};
  const positions = data.destinationListPositions ?? [];

  return {
    countries: adaptCountries(positions),
    cities: adaptDepartureCities(data.departureCities ?? []),
    defaultCriteria: buildDefaultCriteriaIndex(positions),
  };
}
